import { actions } from '../constants/assignment';
import * as actionTypes from '../../models/action/assignment';
import { Log } from 'ng2-logger';
import { IAction } from '../../models/action/core';
import { IStudents, IFilterAssignmentStudents } from '../../models/components/add-assignment';
import { IPagedQueryS } from '../../models/components/paginate';
import { ISetAssignmentStudentList, IAssignmentStudentList } from '../../models/action/assignment';

const _logger = Log.create('assignment-store-action');

// #region Add Assignment Action
export function addAssignmentGetAction(data: actionTypes.IAssignmentData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetAddAssignment {
    return {
        AssignmentData: data,
        timestamp: Date.now(),
        type: actions.ADD_ASSIGMENT_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

// Add Assignement Update Get Action
export function updateAssignmentGetAction(
    dataParams: actionTypes.IAssignmentParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateAssignmentGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_ASSIGNMENT_ACTIVITY
    };
}

export function addAssignmentSetAction(
    AssignmentData: actionTypes.IAssignmentData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddAssignment {
    return {
        AssignmentData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_ASSIGMENT_SET_ACTIVITY
    };
}
// #endregion Add Assignment Action

export function setAssignmentDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ASSIGNMENT_DATA_DEFAULT
    };
}

// #region Add Assignment Action
export function deleteAssignmentGetAction(data: actionTypes.IDeleteData): actionTypes.IGetDeleteAssignment {
    return {
        AssignementData: data,
        timestamp: Date.now(),
        type: actions.DELETE_ASSIGNMENT_ACTIVITY
    };
}

export function deleteAssignmentSetAction(deleteAssignmentStatus: boolean): actionTypes.ISetDeleteAssignment {
    return {
        deleteAssignmentStatus,
        timestamp: Date.now(),
        type: actions.DELETE_ASSIGNMENT_SET_ACTIVITY
    };
}
// #endregion Add Assignment Action

export function sendAssigmentGetAction(data: actionTypes.ISendAssignmentData, UploadCount: number, callback?: (value: boolean) => void): actionTypes.IGetSendAssignment {
    return {
        AssignmentData: data,
        timestamp: Date.now(),
        callback,
        type: actions.SEND_ASSIGNMENT_GET,
        UploadCount
    };
}

export function updateUploadCount(uploadCount: number, enrollmentId: string): actionTypes.IUpdateAssignmentUploadCount {
    return {
        timestamp: Date.now(),
        type: actions.UPDATE_ASSIGNMENT_UPLOADEDCOUNT,
        enrollmentId,
        uploadCount
    };
}

export function saveGroupIdToStore(groupId: string): any {
    return {
        groupId,
        type: actions.SET_GROUP_ID
    };
}

export function AssignmentStudentList(filters: IFilterAssignmentStudents, paging: any, spinnerId?: string, spinnerType?: 'get' | 'set'): IAssignmentStudentList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_ASSIGNMENT_STUDENT_LIST
    };
}

export function SetAssignmentStudentList(users: IStudents[], filters: any, spinnerId?: string, spinnerType?: 'get' | 'set'): ISetAssignmentStudentList {
    return {
        users,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ASSIGNMENT_STUDENT_LIST
    };
}

export function getMyAssignmentsGetAction(
    Filters: actionTypes.IFilters,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGetMyAssignments {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_ASSIGNMENTS
    };
}

export function getMyAssignmentsSetAction(
    MyAssignments: actionTypes.IMyAssignments[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    isLastActivity?: boolean
): actionTypes.ISetMyAssignments {
    return {
        MyAssignments,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_ASSIGNMENTS,
        isLastActivity
    };
}